import PropTypes from 'prop-types';
import Timeline from 'components/timeline/timeline';
import EmailPrefs from 'components/customerEmailPrefs';
import PurchaseDetails from './POS/purchaseDetails.jsx';
import PurchaseSummary from 'components/purchaseSummary/purchaseSummary';

import TruBlueBanner from './trublue/truBlueBanner';
import TruBlueModal from './trublue/truBlueModal';
import TruBlueRegistration from './truBlueRegistration';
import SearchCustomerModal from './searchCustomerModal';


import DashboardPurchase from './dashboardPurchase.jsx';
import {
  countries,
  dateTimeFormats, emailSendingTypes,
  truBlueRegistrationPeriod, truBlueStatus,
} from 'helpers/constants';
import {canDeleteCustomers} from 'helpers/dataHelpers';

import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import path from 'path';

// Apis
import customerApi from 'api/customer';
import dealerApi from 'api/dealer';
import productApi from 'api/product';
import poolApi from 'api/pool';

// Models
import Dealer from 'models/dealer';
import Customer from 'models/customer';
import CustomerContact from 'models/customerContact';
import CustomerStatistics from 'models/customerStatistics';

// Components
import Scorecard from './scorecardWidget.jsx';
import CustomerPools from './systemWidget.jsx';
import PrintableCustomerReport from 'page/reports/customer/printableCustomerReport';
import IntlWrapper from 'components/layout/intlWrapper';
import CustomIntlWrapper from 'components/layout/customIntlWrapper.jsx';

// Libs
import events from 'lib/events';
import phoneFormat from 'util/phoneformat';
import router from 'lib/router';
import routeUtils from 'util/routeUtils';
import session from 'services/sessionService';

// Display Items
import Header from 'components/layout/header';
import PageFooter from 'components/layout/pageFooter';
import FooterButton from 'components/layout/footerButton';
import FooterDeleteButton from 'components/layout/footerDeleteButton';
import EmailModal from 'components/layout/emailModal';
import Loader from 'components/loader';
import {Button} from 'components/layout';


import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import moment from 'moment';

// This constant will determinate the emails content language, I tried to make it custom per user, but this content can be send to one or any contacts at the same time
// so, everyone of them will receive the same content.
const EmailsLanguage = 'en-US';

// // Register in router
let render = (container, params) => {
  console.info('[UI.page.customer] rendering page');
  let _id;
  let _contactid;

  if (params.id) {
    _id = parseInt(params.id.split('.')[0]);
    _contactid = parseInt(params.id.split('.').length > 1 ? params.id.split('.')[1] : null);
  }

  ReactDOM.render(
    <IntlWrapper>
      <WrappedCustomerViewPage
        id={_id}
        contactId={_contactid}
        subPageName={params.subPage}
      />
    </IntlWrapper>,
    container);
  events.publish('page-change', {page: 'customer'});
};

console.info('[UI.page.customer] register route');
router.rr.add([{path: 'customer/:id', handler: routeUtils.requireAuth(render)}]);
router.rr.add([{path: 'customer/:subPage/:id', handler: routeUtils.requireAuth(render)}]);

// Page object
class CustomerViewPage extends React.Component {
  static defaultProps = {
    subPageName: 'account',
  };

  static propTypes = {
    contactId: PropTypes.number,
    id: PropTypes.number,
    intl: intlShape.isRequired,
    subPageName: PropTypes.string,
  };

  state = {
    user: session.getUser(),
    dealer: new Dealer({}),
    customer: new Customer({
      customerContacts: [new CustomerContact({})],
    }),
    customerStatistics: new CustomerStatistics({visble: false}),
    showCustomerModal: false,
    printCustomLanguage: null,
    customerEmailPrefs: null,
    showTruBlueMessageModal: false,
    showTrublueRegitratioModal: false,
  };

  componentWillMount() {
    let apis = [];

    apis.push(dealerApi.getDealer(this.state.user.dealerId));
    apis.push(customerApi.getCustomer(this.props.id));
    apis.push(customerApi.getCustomerStatistics(this.props.id));
    apis.push(productApi.getProducts());
    Promise.all(apis)
      .then(([dealer, customer, customerStatistics, products]) => {
        this.setState({
          dealer: dealer,
          customer: customer,
          customerStatistics: customerStatistics,
          products: products,
          loaded: true,
        });
      })
      .catch(err => {
        console.error(err);
        events.publish('error.user', {message: this.props.intl.formatMessage({id: 'general.error.load.customer'})});
      });

    this.customerChangeListener = events.subscribe('customer-change', () => {
      customerApi.getCustomer(this.props.id)
        .then(customer => this.setState({customer: customer}));
    });

    events.publish('scanner.customer', {customerID: this.props.id});
    events.subscribe('view.custom.email.prefs', this.setCustomerEmailLanguage);
    events.publish('get.language', {locale: EmailsLanguage, event: 'view.custom.email.prefs'});
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.id !== this.props.id) {
      customerApi.getCustomer(nextProps.id)
        .then(customer => this.setState({customer: customer}));
    }
  }

  componentWillUnmount() {
    this.customerChangeListener.remove();
  }

  getAccountPage = (contact, contactName) => {
    return <section>
      {this.state.dealer.isTruBlueEligible ?
        <div className='row'>
          <div className='col-md-12'>
            <TruBlueBanner customer={this.state.customer}
                           pools={this.state.customer.pools}
                           contactName={contactName}
                           manageTruBlueState={this.manageTruBlueState}/>
          </div>
        </div> :
        null}
      <div className='row'>
        <div className='col-md-8'>
          {this.getDashboardPurchase()}
          {this.getCustomerSection()}
          {this.getContactSection()}
        </div>
        <div className='col-md-4'>
          <Scorecard
            customer={this.state.customer}
            dealer={this.state.dealer}
            toggleFavourite={this.toggleFavourite}
            toggleCustomerSearchModal={this.toggleCustomerSearchModal}
            areSystemsOnMaintenance={this.state.customer.pools && this.state.customer.pools.find(e => e.isInMaintenance)}
          />

          <CustomerPools
            pools={this.state.customer.pools}
            customer={this.state.customer}
            dealer={this.state.dealer}
            contact={contact}
          />
        </div>
      </div>
    </section>;
  };

  setCustomerEmailLanguage = data => {
    this.setState({customerEmailPrefs: data});
  };

  getContactSection = () => {
    ///Enable Last Water test Email if pools have prev analysis date.
    let enableLastWaterTest = false;

    if (this.state.customer.pools) {
      this.state.customer.pools.map(p => {
        if (!enableLastWaterTest && p.prevAnalysisDate !== null) {
          enableLastWaterTest = true;
        }
      });
    }
    let contacts = this.state.customer.customerContacts.filter(cc => !cc.deleted).map((contact, index) => {
      let heading;

      if (contact.nameFirst || contact.nameLast) {
        heading = (contact.nameFirst || '') + ' ' + (contact.nameLast || '');
        heading += contact.organization ? ' | ' + contact.organization : '';
      } else {
        heading = contact.organization;
      }

      return <div className='panel panel-default'
                  key={index}>
        <div className='panel-heading'>{(heading || '').trim()}</div>
        <div className='panel-body'>
          <div className='row'>
            {contact.email ?
              <div className='col-md-6'>
                <div className='form-group'>
                  <label><FormattedMessage id='general.email'/></label>
                  <p>{contact.email}</p>
                </div>
              </div> :
              null}
            {contact.homePhone ?
              <div className='col-md-6'>
                <div className='form-group'>
                  <label><FormattedMessage id='general.phone.number'/>
                    <span className='dim n'>(<FormattedMessage id='general.primary'/>)</span></label>
                  <p>{phoneFormat(contact.homePhone)}</p>
                </div>
              </div> :
              null}
            {contact.workPhone ?
              <div className='col-md-6'>
                <div className='form-group'>
                  <label><FormattedMessage id='general.phone.number'/>
                    <span className='dim n'>(<FormattedMessage id='general.alternate'/>)</span></label>
                  <p>{phoneFormat(contact.workPhone)}</p>
                </div>
              </div> :
              null}
            {contact.mobilePhone ?
              <div className='col-md-6'>
                <div className='form-group'>
                  <label><FormattedMessage id='general.phone.number'/>
                    <span className='dim n'>(<FormattedMessage id='general.alternate'/>)</span></label>
                  <p>{phoneFormat(contact.mobilePhone)}</p>
                </div>
              </div> :
              null}
            {contact.email ?
              <EmailPrefs enableLastWaterTest={enableLastWaterTest}
                          email={contact.email}
                          dealer={this.state.dealer}
                          customer={this.state.customer}
                          products={this.state.products}/> :
              null}
          </div>
        </div>
      </div>;
    });

    return <div style={{marginTop: '20px'}}>
      {contacts}
    </div>;
  };

  getCustomerSection = () => {
    const language = this.props.intl.locale.substr(0,2);
    let addressFormatted = '';

    addressFormatted += this.state.customer.address1 ? this.state.customer.address1 : '';
    addressFormatted += this.state.customer.address2 ? ' ' + this.state.customer.address2 + ', ' : ', ';
    addressFormatted += this.state.customer.city ? this.state.customer.city + ',' : ',';
    addressFormatted += this.state.customer.state ? ' ' + this.state.customer.state : '';
    addressFormatted += this.state.customer.zip ? ' ' + this.state.customer.zip + ', ' : ', ';
    addressFormatted += this.state.dealer.country === countries.CA ? 'Canada' : 'USA';
    addressFormatted = addressFormatted.replace(' ', '+');

    let verifyLink =
      <span>
        <label><FormattedMessage id='general.address'/>&nbsp;&nbsp;&nbsp;&nbsp;</label>
      </span>;

    if (this.state.customer.addressVerified) {
      verifyLink =
        <span>
          <div className='form-control-static'>
            <span className='bl bl-checkmark_circle fa-lg blue'/>
            <label><FormattedMessage id='general.address'/>&nbsp;&nbsp;&nbsp;&nbsp;</label>
          </div>
        </span>;
    } else {
      verifyLink =
        <span>
          <label><FormattedMessage id='general.address'/>&nbsp;&nbsp;&nbsp;&nbsp;</label>
          <div className='form-control-static'>
            <span>
              <i className='bl bl-search fa-lg blue'/>
              &nbsp;
              <a href={`#/customer/${this.state.customer.id}/edit`}><FormattedMessage id='general.verify'/></a>
            </span>
          </div>
        </span>;
    }

    let mapLink;

    if (this.state.customer.address1 && this.state.customer.city) {
      mapLink =
        <div className='form-control-static'>
          <span>
            <i className='bl bl-map-link fa-lg blue'/>
            <a href={`https://www.google.ca/maps/search/?hl=${language}&api=1&query=${addressFormatted}/`}
               target='_blank'><FormattedMessage id='general.map'/></a>
          </span>
        </div>;
    }

    return <div>
      <h2>
        <FormattedMessage id='customer.account.details'/>
        <span className='pull-right'
              style={{fontSize: '13px'}}
              onClick={this.edit}>+ <a className='pointer'
                                       onClick={() => window.location.hash = path.join('customer/' + this.props.id, '/edit?add-contact')}>
                <FormattedMessage id='customer.add.contact'/></a>
        </span>
      </h2>
      <div className='grey-box'>
        <div className='flex-col flex-col-small'>
          <div>
            <label><strong><FormattedMessage id='general.alexid'/></strong><span className='value'>{this.state.customer.accountNum}</span></label>
          </div>
          <div>
            {this.state.customer.POSVendorID ?
              <label><strong><FormattedMessage id='general.posid'/></strong><span className='value'>{this.state.customer.POSVendorID}</span></label> :
              null}
            {this.state.customer.truBlueMemberID && this.state.customer.truBlueStatus === truBlueStatus.Active ?
              <label>
                <strong><FormattedMessage id='general.trublue.memberID'/></strong><span className='value'>{this.state.customer.truBlueMemberID}</span>
              </label> :
              null}
          </div>
        </div>
        <div className='flex-col flex-col-big'>
          {verifyLink}
          {mapLink}
          <p>
            {this.state.customer.address1} {this.state.customer.address2} |
            {this.state.customer.city} {this.state.customer.state ? ' | ' + this.state.customer.state : ' | ' + this.state.dealer.state} |
            {this.state.customer.zip}
          </p>
        </div>
      </div>
    </div>;
  };

  getDashboardPurchase = () => {
    if (this.state.customerStatistics.visible && this.checkPOSPermission()) {
      return <DashboardPurchase
        lastPurchaseAmount={this.state.customerStatistics.lastPurchaseAmount}
        lastPurchaseDate={this.state.customerStatistics.lastPurchaseDate}
        numberAnalysesYTD={this.state.customerStatistics.numberAnalysesYTD}
        lifetimePurchases={this.state.customerStatistics.lifetimePurchases}
        totalPurchaseAmountYTD={this.state.customerStatistics.totalPurchaseAmountYTD}
        avgPurchasePerAnalysis={this.state.customerStatistics.avgPurchasePerAnalysis}
        threeStepPurchase={this.state.customerStatistics.threeStepPurchase}
      />;
    } else {
      return null;
    }
  };

  getSubPages = (contact, contactName) => {
    let {formatMessage} = this.props.intl;
    const {dealer, user, customer} = this.state;
    const subPages = {
      account: {
        className: 'customer-account',
        name: formatMessage({id: 'general.account'}),
        element: this.getAccountPage(contact, contactName),
      },
      timeline: {
        className: 'customer-timeline',
        name: formatMessage({id: 'general.timeline'}),
        element: <Timeline id={this.props.id}
                           customer={customer}
                           dealer={dealer}
                           pos={this.checkPOSPermission()}/>,
      },
    };
    let allowPurchaseDetails = false;

    if (dealer.CurrentPOSIntegration &&
      (user.isDealerAdmin ||
        user.isAdmin && dealer.managerPurchaseHistory ||
        user.isTestStation && dealer.testerPurchaseHistory)) {
      allowPurchaseDetails = true;
    }

    if (allowPurchaseDetails) {
      subPages['purchaseDetails'] = {
        className: 'customer-purchaseDetails', name: formatMessage({id: 'customer.purchase.details'}),
        element: <PurchaseDetails customerID={this.props.id}/>,
      };
      subPages['purchaseSummary'] = {
        className: 'customer-purchase-summary', name: formatMessage({id: 'customer.purchase.summary.title'}),
        element: <PurchaseSummary id={this.props.id}
                                  contactName={contactName}/>,
      };
    }

    return subPages;
  };

  setCustomer = customer => {
    console.log('setCustomer', customer);

    this.setState({customer});
  };

  checkPOSPermission = () => {
    const {user, dealer} = this.state;

    if (user && dealer && dealer.CurrentPOSIntegration === 0) {
      return false;
    }

    if (user.isDealerAdmin) {
      return true;
    }

    if (user.isAdmin && dealer.managerPurchaseHistory) {
      return true;
    }

    return !!(user.isTestStation && dealer.testerPurchaseHistory);
  };

  deleteCustomer = () => {
    customerApi.deleteCustomer(this.state.customer)
      .then(() => window.location.hash = 'customers')
      .catch(err => {
        console.error(err);
        events.publish('error.user', {message: this.props.intl.formatMessage({id: 'customer.error.delete'})});
      });
  };

  manageTruBlueState = isTBRegistrationClosed => e => {

    // Pools that could register to trublue (Eligible, Opportunity, Inactive)
    let poolsActiveCandidates = this.state.customer.pools.filter(p => p.truBlueStatus === truBlueStatus.Eligible ||
      p.truBlueStatus === truBlueStatus.Opportunity ||
      p.truBlueStatus === truBlueStatus.Inactive
    ).length;

    //Show registration modal if pool does not have any pools that could be set as an active or the registration closed date has not been reached
    if (!isTBRegistrationClosed && poolsActiveCandidates) {
      this.toggleTruBlueRegistrationModal();
    } else {
      this.toggleTruBlueMessageModal();
    }
  };

  printCustomer = () => {
    poolApi.getList(this.props.id)
      .then(pools => {
        let customer = this.state.customer;

        customer.pools = pools;
        events.publish('print',
          <IntlWrapper>
            <PrintableCustomerReport customer={customer}
                                     products={this.state.products}
                                     dealer={this.state.dealer}/>
          </IntlWrapper>);
      })
      .catch(e => {
        console.error(e);
        events.publish('error.user', {message: this.props.intl.formatMessage({id: 'customer.error.retrieving.data'})});
      });
  };

  reportEmail = () => {
    let {customer, products, dealer, customerEmailPrefs, loaded} = this.state;

    if (loaded && customerEmailPrefs) {
      return <CustomIntlWrapper data={customerEmailPrefs}>
        <PrintableCustomerReport customer={customer}
                                 products={products}
                                 dealer={dealer}/>
      </CustomIntlWrapper>;
    }
    return <div/>;
  };

  toggleCustomerSearchModal = () => {
    this.setState({
      showCustomerModal: !this.state.showCustomerModal,
    });
  };

  toggleTruBlueMessageModal = () => {
    this.setState({
      showTruBlueMessageModal: !this.state.showTruBlueMessageModal,
    });
  };

  toggleTruBlueRegistrationModal = () => {
    this.setState({
      showTrublueRegitratioModal: !this.state.showTrublueRegitratioModal,
    });
  };

  toggleFavourite = () => {
    let customer = this.state.customer;

    customer.favourite = !customer.favourite;
    customerApi.saveCustomer(customer)
      .catch(() => events.publish('error.user', {message: this.props.intl.formatMessage({id: this.state.dealer.country === countries.CA ?
            'general.error.save.favourite' :
            'general.error.save.favorite',
      })}));
    this.setState({customer: customer});
  };

  toggleInactive = () => {
    let customer = this.state.customer;

    customer.inactive = !customer.inactive;
    customerApi.saveCustomer(customer)
      .catch(() => events.publish('error.user', {message: this.props.intl.formatMessage({id: 'general.error.save.inactive'})}));
    this.setState({customer: customer});
  };

  render() {
    let {dealer, customer} = this.state;
    let {formatMessage} = this.props.intl;
    let pageTitle = '';
    let contact = null;
    let contactName;

    if (this.state.customer.customerContacts.length > 0) {
      contact = this.state.customer.customerContacts[0];

      for (let i = 0; i < this.state.customer.customerContacts.length; i++) {
        if (this.state.customer.customerContacts[i].id === this.props.contactId) {
          contact = this.state.customer.customerContacts[i];
        }
      }

      contactName = contact.nameFirst || contact.nameLast ? (contact.nameFirst || '') + ' ' + (contact.nameLast || '') : contact.organization;

      if (this.state.customer.inactive) {
        pageTitle = <span>{(contactName || '').trim()}
          <span className='inactive'>({formatMessage({id: 'general.inactive'})})</span></span>;
      } else {
        pageTitle = <span>{(contactName || '').trim()} </span>;
      }
    }

    //Generate customer id for url purpose
    let customerUrl = this.props.id;

    if (!isNaN(this.props.contactId)) {
      customerUrl += '.' + this.props.contactId;
    }

    const subPages = this.getSubPages(contact, contactName);

    const subPagesTabs = Object.keys(subPages)
      .map(sp =>
        <a key={sp}
           className={this.props.subPageName === sp ? subPages[sp].className + ' active' : subPages[sp].className}
           href={'#customer/' + sp + '/' + this.props.id}>{subPages[sp].name}
        </a>);

    const subPage = subPages[this.props.subPageName] && subPages[this.props.subPageName].element;

    if (this.state.loaded && !subPage) {
      location.hash = '';
    }

    return <div className='container'
                id='page-customer'>
      <Header mainTitle={formatMessage({id: 'customer.analysis.title'})}
              mainTitleReturn='customers'
              subTitle={pageTitle}>
      </Header>

      {this.state.showCustomerModal ?
        <SearchCustomerModal onClose={this.toggleCustomerSearchModal}
                             customerID={customer.id}/> :
        null}

      {this.state.showTruBlueMessageModal ?
        <TruBlueModal onClose={this.toggleTruBlueMessageModal}>
          <div className='trublue-modal__section'>
            <h1 className='trublue-modal__section-title'>
              {customer.truBlueMemberID ?
                <FormattedMessage id='trublue.modal.customer.registered'
                                  values={{
                                    year: moment().year(),
                                  }}/> :
                <FormattedMessage id='trublue.modal.customer.closed'
                                  values={{
                                    year: moment().year(),
                                    date: truBlueRegistrationPeriod.end.format(dateTimeFormats.numeralDate),
                                  }}/>}
            </h1>
          </div>
          <div className='trublue-modal__controls'>
            <Button default
                    onClick={this.toggleTruBlueMessageModal}><FormattedMessage id='general.cancel'/></Button>
          </div>
        </TruBlueModal> :
        null}

      {this.state.showTrublueRegitratioModal ?
        <TruBlueRegistration products={this.state.products}
                             customer={this.state.customer}
                             onClose={this.toggleTruBlueRegistrationModal}
                             dealer={this.state.dealer}
                             setCustomer={this.setCustomer}
                             onSuccess={this.toggleTruBlueMessageModal}/> :
        null}

      <nav className='navigation-tabs'>
        {subPagesTabs}
      </nav>

      <Loader loaded={this.state.loaded}>
        {subPage}
        {this.props.subPageName !== 'timeline' && this.props.subPageName !== 'purchaseSummary' && this.props.subPageName !== 'purchaseDetails' ?
          <PageFooter>
            <FooterButton
              label={formatMessage({id: 'general.notes'})}
              icon='bl bl-2x bl-notes'
              onClick={() => window.location.hash = path.join('customer/' + customerUrl, 'notes')}/>
            {canDeleteCustomers(session.getUser().privileges, dealer) ?
              <FooterDeleteButton onDelete={this.deleteCustomer}
                                  enabled={!!this.props.id}
                                  label={formatMessage({id: 'customer.delete'})}/> :
              ''}
            <FooterButton
              label={this.state.customer.inactive ? formatMessage({id: 'general.inactive'}) : formatMessage({id: 'general.active'})}
              icon={this.state.customer.inactive ? 'bl bl-toggle-off fa-2x' : 'bl bl-toggle-on fa-2x'}
              onClick={this.toggleInactive}/>
            <EmailModal
              title={formatMessage({id: 'customer.email.modal.title'})}
              subject={formatMessage({id: 'customer.email.modal.subject'})}
              baseMessage={ReactDOMServer.renderToString(this.reportEmail())}
              customerID={this.state.customer.id || 0}
              type={emailSendingTypes.direct}
            />
            <FooterButton
              label={formatMessage({id: 'general.edit'})}
              icon='bl bl-2x bl-edit'
              onClick={() => window.location.hash = path.join('customer/' + customerUrl, 'edit')}/>
            <FooterButton label={formatMessage({id: 'general.print'})}
                          icon='bl bl-2x bl-print'
                          onClick={this.printCustomer}/>
          </PageFooter> :
          ''}
      </Loader>

    </div>;
  }
}

const WrappedCustomerViewPage = injectIntl(CustomerViewPage);

export default WrappedCustomerViewPage;
